import { render } from "./payment_approval.html?vue&type=template&id=3def2a0d&external"
import script from "./payment_approval.js?vue&type=script&lang=js&external"
export * from "./payment_approval.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__